import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";

import App from "./containers/App";
import reducer from "./store/reducers/authReducer";
import { OberinStoreContextProvider } from "./hooks";

import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/skins/ui/oxide/content.min.css";
import "tinymce/skins/content/default/content.min.css";
import "@fortawesome/fontawesome-free/css/all.css";

import "./css/main.scss";
import "typeface-roboto/index.css";

import Auth from "./containers/Auth";

const store = createStore(reducer, applyMiddleware(thunk));

// When a new deployment replaces JS chunks, lazy-loaded routes will fail with a
// ChunkLoadError for users who are already on the site. Prompt them to refresh.
window.addEventListener("unhandledrejection", function (event) {
    const message: string =
        event.reason && event.reason.message ? event.reason.message : "";
    if (
        message.includes("Loading chunk") ||
        message.includes("ChunkLoadError")
    ) {
        if (
            window.confirm(
                "A new version of the site is available. Refresh now?",
            )
        ) {
            window.location.reload();
        }
    }
});

// Create the application
const app = (
    <Provider store={store}>
        <OberinStoreContextProvider
            configuration={{
                count: {
                    initialValue: 10,
                },
            }}
        >
            <BrowserRouter>
                <Auth>
                    <App />
                </Auth>
            </BrowserRouter>
        </OberinStoreContextProvider>
    </Provider>
);

ReactDOM.render(app, document.getElementById("root"));
